<template>
  <div class="container container-global">
    <h2>Le progestatif injectable (DEPO PROVERA)</h2>
    <div class="content">
      <br />
      <span>Mode d’efficacité: </span>
      <ul>
        <li>
          axe hypothalomo-hypophysaire effet antigonadrope =inhibition de la
          sécrétion des gonadotrophines et blocage de l’ovulation
        </li>
        <li>endomètre : atrophie de l’endomètre</li>
        <li>glaire cervicale : la glaire devient imperméable</li>
      </ul>
      <span>Comment la prescrire ? </span>
      <br />
      <br />
      <p>
        Une injection d’acétate de médroxyprogestérone 150 mg en intra
        musculaire profonde tous les 3 mois.
        <br />
        <br />
        A initier dans les 5 premiers jours du cycle. Respecter 7 jours de délai
        après un accouchement ou une IVG.
        <br />
      </p>
      <br />
      <span>Efficacite</span>
      <br />
      <br />
      <p>Indice de pearl : 0,3%</p>
      <br />
      <span>Contre-indications: </span>
      <br />
      <br />
      <p>
        cancer du sein ou de l’endomètre
        <br />
        maladie veineuse thromboembolique présente ou ancienne
        <br />
        AVC, SCA
        <br />
        obésité, diabète, HTA
        <br />
        pathologie hépatique
      </p>
      <br />
      <span>Effets Secondaires:</span>
      <br />
      <br />
      <p>
        Troubles du cycle et prise de poids
        <br />
        Risque d’ostéopénie à long terme
        <br />
      </p>
      <br />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/scss/variables/colors.scss";
@import "@/assets/styles/scss/variables/mixin.scss";

.container {
  margin-top: 37px;
  .content {
    margin-top: 15px;
    p {
      color: $text-color-aigm;
    }
    span {
      color: $dark-pink;
      text-decoration: underline;
    }
    ul {
      margin: 15px auto 15px auto;
      width: 90%;
      li {
        margin-top: 10px;
        color: $text-color-aigm;
      }
    }
  }
}
</style>
